
import { ApiResponse } from "../utils/api/ApiProps";
import { RolesApiData } from "../types/settings/RoleTypes";
import api from "../utils/api";
// import { useRouter } from 'react-router-dom';
// import { CreateUserRequest, UsersDetail } from "../types/settings/UsersTypes";


interface GetRoleParams {
    page?: number;
    search_term?: string;
    sort_column?: string;
    sort_order?: "ASC" | "DESC";
  }
  // interface GetUserParams {
  //  uuid:string;
  // }
//get roles
  // export const getRoles = async ({
  //   page = 1,
  //   search_term = "",
  //   sort_column,
  //   sort_order,
  // }: GetRoleParams = {}): Promise<ApiResponse<RolesApiData>> => {
  //   try {
  //     const searchParams = new URLSearchParams();

  
  //     searchParams.append("page", page.toString());
  //     if (search_term) searchParams.append("search_term", search_term);
  //     if (sort_column) searchParams.append("sort_column", sort_column);
  //     if (sort_order) searchParams.append("sort_order", sort_order);
  
  //     const queryString = searchParams.toString();
  //     const url = queryString ? `/roles?${queryString}` : "/roles";
  
  //     const response = await api.get<RolesApiData>(url);

  //     return response;
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  export const getRoles = async ({
    page = 1,
    search_term = "",
    sort_column,
    sort_order,
  }: GetRoleParams = {}): Promise<ApiResponse<RolesApiData>> => {
    const searchParams = new URLSearchParams();
  
    searchParams.append("page", page.toString());
    if (search_term) searchParams.append("search_term", search_term);
    if (sort_column) searchParams.append("sort_column", sort_column);
    if (sort_order) searchParams.append("sort_order", sort_order);
  
    const queryString = searchParams.toString();
    const url = queryString ? `/roles/?${queryString}` : "/roles/";

    // Directly returning the response without try-catch
    return api.get<RolesApiData>(url);
  };


  export const getUserById = async (
    uuid: string
  ): Promise<ApiResponse<{ data: any }>> => {
    const response = await api.req<any>({
      url: `/roles/${uuid}`,
      method: api.Method.GET,
    });
    return response;
  };
  
  // Create role function
export const createRole = async (
    data: any
  ): Promise<ApiResponse<{ data: any }>> => {
    const response = await api.req<any>({
      url: "/roles",
      method: api.Method.POST,
      body: data,
    });
    // console.log(response);
    return response;
  };
  
  // Update role function
  export const updateRole = async (
    uuid: string,
    data: any
  ): Promise<ApiResponse<{ data: any }>> => {
    const response = await api.req<any>({
      url: `/roles/${uuid}`,
      method: api.Method.POST,
      body: data,
    });
    // router.refresh();
    return response;
  };
  
  export const deleteRole = async (
    uuid: string
  ): Promise<ApiResponse<{ data: any }>> => {
    try {
      const response = await api.req<{ data: any }>({
        url: `/roles/${uuid}`,
        method: api.Method.DELETE,
      });
  
      if (response.status !== "success") {
        throw new Error(response.message || "Failed to delete role");
      }
  
      return response;
    } catch (error) {
      console.error(`Error deleting role ${uuid}:`, error);
      throw new Error("Failed to delete ");
    }
  };
  
    
  




 
  